import React from 'react';

// import { State, City }  from 'country-state-city';

import State from '../../Component/LocationFiles/indiaStates.json';
// import City from '../../Component/LocationFiles/indiaCities.json';
import City from '../../Component/LocationFiles/indiaDistricts.json';



export default function Component(props) {

const { question, answersList, handleDropdownSelect, handleRadio, surveyLanguageCode, storeStateCode, surveyScreenData } = props;


function CustomLabels(optionID,optionName, question){
  // let surveyLanguageCode = "customNPS";
  return  (surveyLanguageCode!=='')?
  (question && question.transl && 
    question.transl[surveyLanguageCode] && 
    question.transl[surveyLanguageCode]["optionsList"] &&
        question.transl[surveyLanguageCode]["optionsList"][optionID])?
          question.transl[surveyLanguageCode]["optionsList"][optionID]:optionName
  :optionName
}



let [showDropdownQues, openDropdownQuestion] = React.useState(true);


// let CountryData = Country.getAllCountries();
let StatesData = State.filter(x=>x.countryCode==="IN");
let CitiesData = storeStateCode?  ( City.filter(x=>x.countryCode==="IN").filter(x=>x.stateCode===storeStateCode) )  :  ""  ;


function ReplaceCityName (list){
  let outputList = []
  if(list && list.length>0){
    list.forEach((item)=>{


      if(storeStateCode==="RJ" && (item.name==='Churu')){
        outputList.push({
          "name":"Chomu"
        });
      }


      if(item && item.name && (item.name==='Jhunjhunun')){
        let temp = {
          ...item
        }
        temp["name"] = 'Jhunjhunu';
        outputList.push(temp);
      }
      else if(item && item.name && (item.name==='Bhasawar')){
        let temp = {
          ...item
        }
        temp["name"] = 'Bhusawar';
        outputList.push(temp);
      }
      else{
        outputList.push(item)
      }


    });
  }



  outputList.sort((a,b)=>(a.name ).charCodeAt(0) - (b.name).charCodeAt(0))

  return outputList
}



StatesData.sort((a,b)=>(a.name ).charCodeAt(0) - (b.name).charCodeAt(0))

// console.log("Country:-",CountryData)
// console.log("States:-",StatesData)
// console.log("Cities:-",CitiesData)

let DataList = [];
let type = (question && question.transl && question.transl["customLocation"] && question.transl["customLocation"]["type"])? question.transl["customLocation"]["type"]:"";

let label = "Select Item";
if(type==="state"){
  DataList = StatesData;
  label = CustomLabels("state", "Select State",question);
}
else if(type==="city"){
  DataList = ReplaceCityName(CitiesData);
  label = CustomLabels("city", "Select District",question);
}

// console.log("label============>",label)

return(
    <>

        <div className="py-6  lg:text-base text-sm font-normal  mb-4 gap-2 mr-auto lg:w-11/12 ml-1 mr-4">
          <div 
          style={{
            borderBottomColor:(surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor : "#757575",
          }}
          className="ml-1 relative w-11/12 border-b border-gray-500  border-opacity-70 cursor-pointer focus:border-opacity-100 focus:border-b-2 py-2 text-gray-500 flex justify-between">
            <p onClick={()=>openDropdownQuestion(!showDropdownQues)}
            className="text-lg mx-2 "
            style={{color:(surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor : "#757575"}}
            >{
              (answersList && answersList.length > 0 && answersList.findIndex(item => item.questionId === question.id) !== -1) ?
                answersList[answersList.findIndex(item => item.questionId === question.id)].answer?answersList[answersList.findIndex(item => item.questionId === question.id)].answer:(label)
                : (label)
              }</p> <span
              style={{color:(surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor : "#757575"}}
              className="material-icons">arrow_drop_down</span>
            {/* drop down */}

            {showDropdownQues && DataList && DataList.length>0?
            <div className="absolute top-12 left-1 right-2 w-full bg-white text-gray-600 divide-y text-base rounded-lg overflow-hidden h-60 overflow-y-auto mt-4">
            {DataList && DataList.length>0?
              DataList.map((option, optionindex) =>
              <span 
                key={optionindex}
                onClick={()=>{
                  handleDropdownSelect(option.name);
                  openDropdownQuestion(!showDropdownQues);
                  handleRadio(optionindex, question, option); 
                }}
                className=" block py-2 px-4 hover:bg-gray-100">{option.name}</span>
              ):null}
            </div>
             :null}



          </div>
          </div>



    </>
  );}